fx.ns("desktop.book.edition", class TopNotifications extends fx.Component {
    
	constructor(data)
	{
		super(data);

        this.showEffect = "hslideout";
        this.hideEffect = "hslideout";
        this._width = 350;
        this._height = 100;
        this.listenUpdates(fx.get("settings"), true);
    }

    create()
    {
        let person = new shared.component.Person(fx.get("assets").personSure);
        this.vbox = new fx.components.VBox("content");
        this.title = new fx.components.Text({className : "title"});
        this.text = new fx.components.Text({className : "text"});
        this.exit = new fx.components.Image({data : fx.assets.ExitNotifIcon});
        this.addChild(person , {width:70, height : 70, left : 15, top: 15});
        this.vbox.addChild(this.title);
        this.vbox.addChild(this.text);
        this.addChild(this.vbox, {left : 85, top : 50});
        this.addChild(this.exit, {width: 10, height: 10, right : 15, top : 10});
    }

    onReady()
    {
        this.on("click", this.hide);
    }

    onDataEvent(e)
	{
		super.onDataEvent(e);
        if(e.type == "mobile-upload-finished"){
            this.title.text = fx.text("Téléchargement des photos mobile terminé !");
            this.text.text = fx.text("Les photos ont bien été téléchargées depuis votre mobile");
            this.width(this._width);
            this.height(this._height);
            this.show();
        }
        else if(e.type == "grid-notification")
        {
            this.title.text = fx.text(e.data.gridmode ? "Grille activée" : "Grille désactivée");
            this.text.text = fx.text(e.data.gridmode ? "La grille de repère est maintenant activée" : "La grille de repère est maintenant désactivée");
            this.width(this._width);
            this.height(this._height);
            this.show();
        }
        else if(e.type == "pdf-upload-notification")
        {
            this.title.text = fx.text("Votre fichier a été importé");
            this.text.text = fx.text("Il a été ajouté à vos photos");
            this.width(this._width);
            this.height(this._height);
            this.show();
        }
	}

    show()
    {
        super.show()
        this.delay(this.hide, 5000)
    }

});